import { render, staticRenderFns } from "./step-questions.vue?vue&type=template&id=894da86e"
import script from "./step-questions.vue?vue&type=script&lang=js"
export * from "./step-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports